import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import LoadingLockScreen from '@/main/components/shared/loadingLockScreen/loadingLockScreen';
import {
  ClaimGridItemDetailResponse,
  ClaimGridItemPartResponse,
  ClaimSearchGridResponse
} from '@/main/models/response';

import GridCollapseSearchClaim from './gridCollapseSearchClaim/gridCollapseSearchClaim';
import HeaderCollapseSearchClaim from './headerCollapseSearchClaim/headerCollapseSearchClaim';
import * as S from './styles';
import { useState, useMemo } from 'react';

interface ICollapseSearchClaimProps {
  isLoadingDetailClaim: boolean;
  isLoadingDataParts: boolean;
  dataGrid: ClaimSearchGridResponse;
  dataDetailClaim: ClaimGridItemDetailResponse | null;
  dataParts: ClaimGridItemPartResponse[] | null;
  updateGridPartByGuidQuoteItem: (
    guidQuoteItem: string,
    objUpdate: Partial<ClaimGridItemPartResponse>
  ) => void;
  refreshClaim: () => void;
  refreshClaimCounts: () => void;
}

function CollapseSearchClaim({
  dataGrid,
  dataDetailClaim,
  dataParts,
  isLoadingDetailClaim,
  isLoadingDataParts,
  refreshClaim,
  refreshClaimCounts,
  updateGridPartByGuidQuoteItem
}: ICollapseSearchClaimProps) {
  const [isLoading, setIsLoading] = useState(false);

  const otherLoading = useMemo(() => isLoading, [isLoading]);

  if (isLoadingDataParts && isLoadingDetailClaim) return <LoadingComponent />;

  return (
    <S.Container>
      {otherLoading && <LoadingLockScreen />}

      <HeaderCollapseSearchClaim
        dataGrid={dataGrid}
        dataDetailClaim={dataDetailClaim}
        isLoadingDetailClaim={isLoadingDetailClaim}
        refreshClaim={refreshClaim}
        refreshClaimCounts={refreshClaimCounts}
        setIsLoading={setIsLoading}
      />
      <GridCollapseSearchClaim
        dataGrid={dataGrid}
        isLoadingDataParts={isLoadingDataParts}
        dataParts={dataParts}
        updateGridPartByGuidQuoteItem={updateGridPartByGuidQuoteItem}
        refreshClaim={refreshClaim}
      />
    </S.Container>
  );
}

export default CollapseSearchClaim;
